// app/frontend/javascript/controllers/input_focus_controller.js
import ApplicationController from './application'

export default class extends ApplicationController {
  connect() {
    // Position cursor at the end of the input value
    if (this.element) {
      this.element.focus()
      const valueLength = this.element.value.length
      this.element.setSelectionRange(valueLength, valueLength)
    }
  }
}
